import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-stone-50 border-t border-stone-200" data-id="element-136">
      <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-137">
        <div className="inline-flex items-center justify-center p-4 bg-white rounded-full shadow-sm mb-8" data-id="element-138">
          <ShieldCheck className="w-8 h-8 text-stone-800" data-id="element-139" />
        </div>
        <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-140">
          Garantía de Confianza
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-141">
          Sabemos que comprar accesorios online requiere confianza. Tu pedido
          será procesado con cuidado y recibirás un producto que se ve
          exactamente como en las fotos: voluminoso, suave y listo para usar.
        </p>
        <div className="flex items-center justify-center gap-2 text-sm font-medium text-stone-500 uppercase tracking-widest" data-id="element-142">
          <span data-id="element-143">Envío seguro a todo México</span>
          <span className="w-1.5 h-1.5 rounded-full bg-stone-400" data-id="element-144"></span>
          <span data-id="element-145">Calidad Garantizada</span>
        </div>
      </div>
    </section>;
}